import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import courierLogo from '../assets/images/freitora_logo.jpeg'; // Replace with the courier-specific logo
import { toast } from 'react-toastify';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';

const CourierLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [visibility, setVisibility] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const toggleVisibility = () => {
    setVisibility((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const apiUrl = `${process.env.REACT_APP_BASE_URL}/api/user/signin`; // API endpoint for courier login

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        login();
        toast.success('Login Successful');

        setTimeout(() => {
          navigate('/dashboard');
          window.location.reload(); // 🔄 Force refresh to reload everything cleanly
        }, 100);
      } else {
        setError(data.message || 'Login failed');
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error during login:', error);
      toast.error(error.message);
      setError('An error occurred during login. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <body className="bg-secondary min-h-screen pt-12 md:pt-20 pb-6 px-2 md:px-0">
      <main className="bg-white max-w-lg mx-auto p-8 md:p-12 my-10 rounded-lg shadow-2xl">
        <section className="mt-10">
          <img src={courierLogo} alt="Courier Logo" className="w-72 m-auto" />

          <form className="flex flex-col" onSubmit={handleSubmit} noValidate method="POST" action="#">
            <div className="mb-4">
              <label htmlFor="email" className="block mb-1 text-gray-700">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="input input-bordered w-full"
                disabled={loading}
              />
            </div>
            <div className="mb-4">
              <label htmlFor="password" className="block mb-1 text-gray-700">
                Password
              </label>
              <div className="relative">
                <input
                  type={visibility ? "text" : "password"}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="input input-bordered w-full pr-10"
                  disabled={loading}
                />
                <button
                  type="button"
                  onClick={toggleVisibility}
                  className="absolute right-4 top-4 text-gray-600"
                >
                  {visibility ? <MdVisibilityOff /> : <MdVisibility />}
                </button>
              </div>
            </div>
            <button
              className="bg-secondary hover:bg-gray-500 text-white font-bold py-2 rounded shadow-lg hover:shadow-xl transition duration-200"
              type="submit"
              disabled={loading}
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>
        </section>
      </main>

      <div className="max-w-lg mx-auto text-center mt-12 mb-6">
        <p className="text-white">Courier Management System &copy; {new Date().getFullYear()}</p>
      </div>
    </body>
  );
};

export default CourierLogin;
